module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-teaser"
  }, [_c('transition', {
    attrs: {
      "name": "trs-close-header-teaser"
    }
  }, [(_vm.isOpen) ? _c('div', {
    ref: "root",
    staticClass: "header-teaser--root"
  }, [(_vm.teaserPlugin.content.hide_when_closed) ? _c('div', {
    staticClass: "header-teaser--close"
  }, [_c('button', {
    staticClass: "header-teaser--close-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.requestClose($event)
      }
    }
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "close",
      "size": "small"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-teaser--plugins"
  }, [_c(_vm.teaserPlugin.type, {
    tag: "component",
    attrs: {
      "plugin": _vm.teaserPlugin
    },
    on: {
      "request-close": _vm.requestClose
    }
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a2a19c4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2a19c4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-placeholders/header-teaser/index.vue
// module id = 576
// module chunks = 7